import React from 'react';

export const ClipSection = ({
  x,
  y,
  id = 'clip-section',
  height = 800,
  width = 400,
}) => (
  <clipPath id={id}>
    <rect
      height={height}
      width={width}
      x={x}
      y={y}
    />
  </clipPath>
)

export default ClipSection;
